import agent from 'superagent';
import { Provider } from './types/provider.enum';
export class EditorClient {
    constructor(apiEndpoint) {
        this.apiEndpoint = apiEndpoint;
        this.apiEndpoint = this.apiEndpoint.replace(/\/+$/, '');
    }
    /** List every document. There is no pagination so be careful when calling this API */
    async listDocuments() {
        const { body } = await agent.get(`${this.apiEndpoint}/document/`);
        return body;
    }
    /** Get a single document by its identifier */
    async getDocumentById(documentId) {
        const { body } = await agent.get(`${this.apiEndpoint}/document/${documentId}`);
        return body;
    }
    /** Get a single videoma document */
    async getVideomaDocument(videomaId) {
        return this.getDocumentByProvider(Provider.Videoma, videomaId);
    }
    /** Get a single document by its provider identifier */
    async getDocumentByProvider(provider, providerId) {
        const { body } = await agent.get(`${this.apiEndpoint}/document/by-provider/${provider}/${providerId}`);
        return body;
    }
    /** Create a new named document */
    async createNamedDocument(name) {
        const { body } = await agent.post(`${this.apiEndpoint}/document`).send({ name });
        return body;
    }
    /** Update a document by its identifier */
    async updateDocumentById(documentId, update) {
        const { body } = await agent.put(`${this.apiEndpoint}/document/${documentId}`).send(update);
        return body;
    }
    /** Remove a document by its identifier */
    async deleteDocumentById(documentId) {
        await agent.del(`${this.apiEndpoint}/document/${documentId}`);
    }
    /** Get the audio peaks by document identifier */
    async getDocumentAudioPeaks(documentId) {
        const { body } = await agent.get(`${this.apiEndpoint}/document/${documentId}/audio`);
        return body;
    }
    /** Create the audio peaks for the given document identifier */
    async createDocumentAudioPeaks(documentId, peaks) {
        const { body } = await agent.post(`${this.apiEndpoint}/document/${documentId}/audio`).send(peaks);
        return body;
    }
    /** Create action log */
    async postActionTime(actionTime) {
        await agent.post(`${this.apiEndpoint}/logs`).send(actionTime);
    }
    /** Get users */
    async getUsers() {
        const { body } = await agent.get(`${this.apiEndpoint}/users`);
        return body;
    }
    /**
     * Mark the verifiable sentences present in a document
     * @param documentId The document identifier
     * @param options The options passed to the prediction algorithm
     */
    async markDocumentById(documentId, options = {}) {
        const { body } = await agent.post(`${this.apiEndpoint}/document/${documentId}/mark`).query(options);
        return body;
    }
    /**
     * Notify the editor back-end a new stream chunk has been processed by video
     * and needs to update the corresponding document. Return the document id
     *
     * @param videomaId The videoma identifier of the chunk
     */
    async sendStreamChunk(videomaId) {
        const { body } = await agent.post(`${this.apiEndpoint}/streams`).send({ videomaId });
        body.metadata.start = new Date(body.metadata.start);
        return body;
    }
}
